import React from 'react';
import PropTypes from 'prop-types';
import adsicon from './icon.png';

export class BusinessNameWithAds extends React.PureComponent {
  render() {
    return (
      <div className="business-name-with-ads">
        {
          !this.props.hideLabel &&
          <span className="adslabel">
            {this.props.i18n.getString('Entity_Ads')}
          </span>
        }
        { !this.props.onlyIcon &&
          <span className="business-name">
            {this.props.businessName}
          </span>
        }
        {
          this.props.showAdsIcon &&
          <img className="ads-icon" alt="icon" src={adsicon} />
        }
      </div>
    );
  }
}

BusinessNameWithAds.propTypes = {
  businessName: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onlyIcon: PropTypes.bool,
  hideLabel: PropTypes.bool,
};

BusinessNameWithAds.defaultProps = {
  onlyIcon: false,
  hideLabel: false,
};
